<template>
    <div style="display: flex; place-content: center;">
        <div style="display: flex; flex-direction: column; width: 80%; padding-top: 20px;">
            <div id="Notification">
                このチャットボットのご利用はご注意ください。お問い合わせの長さによって費用が発生します。
                可能な限り、3つのフィルターをすべて使用して、分析に使用する製品の数を最小限に抑えてください。
                各製品には、各小売店の販売データなどが含まれているためです。また、ご質問は、弊社の製品分析に関するものに限ってください。
                <p>このボットはまだテスト中です。間違った答えが出る可能性が非常に高いです。</p>
            </div>
            <div>チャット：</div>
            <div id="ChatHistory">

            </div>
            <div id="InputContainer">
                <div>入力：</div>
                <input id="AI_UserInput" @input="UpdatePromptCostEstimation"/>
                <button id="SendMessageButton" :disabled="Prompt.trim() === ''" @click="SendMessage">Send</button>
            </div>
            <!-- <div id="CostEstimationBox">
                <div>
                    <p style="border-bottom: 1px solid gray; text-align: center;">経費見込</p>
                    <p>質問のトーケン数：~{{ CurrentPromptTokenEstimation }}</p>
                    <p>質問の経費見込：$ {{ CurrentPromptCostEstimation }}</p>
                </div>
            </div> -->
            <!-- <div id="Filters" style="display: flex;">
                <div id="FactoryFilterContainer">
                    <div class="FilterTitle">工場</div>
                    <div class="FilterElement RoundShadowElement">
                        <GenericMultiDropdown id="FactoryFilter" ref="FactoryFilter" :InputPlaceholder="'工場を選択'" :options="FactoryOptions" :OnChange="OnFactoryChange" />
                    </div>
                </div>
                <div id="SeriesFilterContainer">
                    <div class="FilterTitle">シリーズ</div>
                    <div class="FilterElement RoundShadowElement">
                        <GenericMultiDropdown id="SeriesFilter" ref="SeriesFilter" :InputPlaceholder="'シリーズを選択'" :options="SeriesOptions" :OnChange="OnSeriesChange" />
                    </div>
                </div>
                <div id="BrandFilterContainer">
                    <div class="FilterTitle">ブランド</div>
                    <div class="FilterElement RoundShadowElement">
                        <GenericMultiDropdown id="BrandFilter" ref="BrandFilter" :InputPlaceholder="'ブランドを選択'" :options="BrandOptions" :OnChange="OnBrandChange" />
                    </div>
                </div>
            </div> -->
            <!-- <GenericDropdown :id="'AI_DataTypeSelection'" :options="PromptDataOptions" :OnChange="OnDataTypeChange"/> -->
            <!-- <div id="DataContainer">
                <AiDataEntry v-for="entry in SourceData" :key="entry.id" :Label="entry.name" :ID="entry.id" @change="OnDataSelectionChanged"/>
            </div> -->
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { ShowLoading } from '../utils/FullScreenLoading';
// import GenericDropdown from './components/GenericDropdown.vue';
// import AiDataEntry from './components/AiDataEntry.vue';
// import GenericMultiDropdown from './components/GenericMultiDropdown.vue';

export default{
    components:{
        // GenericDropdown,
        // AiDataEntry,
        // GenericMultiDropdown,
    },
    mounted(){
        const inp = document.getElementById('AI_UserInput');
        inp.addEventListener('keydown', (event)=>{
            if (event.key === 'Enter' &&
                event.target.value.trim() !== '')
            {
                this.SendMessage();
            }
        });

        this.GetChatHistory();
        this.GetFilters();
    },
    methods:{
        async GetChatHistory()
        {
            const param = {
                SessionToken: this.$GetToken(),
                UserID: parseInt(this.$GetUserID()),
            };

            let chatHistory = await axios.post(`${process.env.VUE_APP_BACKEND_URL}ai/chat`, param)
            .then(response => {
                ShowLoading(false);
                return response.data;
            })
            .catch(error => {
                ShowLoading(false);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                console.log('Error when trying to receive source data', error);
                return null;
            });

            if (chatHistory.history === null)
            {
                return;
            }

            for (let i = 0; i < chatHistory.history.length; i++)
            {
                console.log('have message from ', chatHistory.history[i].role);
                if (chatHistory.history[i].role === 'user')
                {
                    this.AppendUserMessage(chatHistory.history[i].content);
                }
                else
                {
                    this.AppendAIMessage(chatHistory.history[i].content);
                }
            }
        },
        async GetFilters()
        {
            this.FactoryOptions = await this.GetFactories();
            this.SeriesOptions = await this.GetSeries();
            this.BrandOptions = await this.GetBrands();
        },
        async SendMessage()
        {
            const inpEl = document.getElementById('AI_UserInput');

            if (inpEl === null)
            {
                return;
            }

            const inp = inpEl.value;
            
            inpEl.value = '';
            this.Prompt = '';
            this.CurrentPromptCostEstimation = 0;

            this.AppendUserMessage(inp);

            ShowLoading(true, 'ローディング中');

            const param = {
                SessionToken: this.$GetToken(),
                UserID: parseInt(this.$GetUserID()),
                UserMessage: inp,
                Filter_Factory: this.SelectedFactories,
                Filter_Series: this.SelectedSeries,
                Filter_Brand: this.SelectedBrands
            };

            console.log('send param', param);

            const response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}ai/analyze`, param)
            .then(response => {
                ShowLoading(false);
                return response.data;
            })
            .catch(error => {
                ShowLoading(false);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                console.log('Error when trying to send OpenAI request', error);
                this.AppendAIMessage(error.response.data.Error);
                return null;
            });

            if (response !== null)
            {
                console.log('Response', response);
                this.AppendAIMessage(response);
            }
        },
        AppendUserMessage(input)
        {
            const chat = document.getElementById('ChatHistory');

            let msgBox = document.createElement('div');
            msgBox.classList.add('Message');

            let who = document.createElement('div');
            who.innerHTML = 'You';
            who.style.fontWeight = 'bold';
            who.style.textAlign = 'right';
            who.style.paddingRight = '5px';
            msgBox.append(who);

            let msg = document.createElement('div');
            msg.classList.add('UserMessage');
            msg.innerHTML = input;

            msgBox.append(msg);
            chat.append(msgBox);

            this.ScrollChatToBottom();
        },
        AppendAIMessage(input)
        {
            const chat = document.getElementById('ChatHistory');

            let msgBox = document.createElement('div');
            msgBox.title = `Query: ${input.Query}`;
            msgBox.classList.add('Message');

            let who = document.createElement('div');
            who.innerHTML = 'SACHIKO-AI';
            who.style.fontWeight = 'bold';
            msgBox.append(who);

            let msg = document.createElement('div');
            msg.classList.add('AIMessage');
            msg.innerHTML = input.Answer;

            msgBox.append(msg);
            chat.append(msgBox);

            this.ScrollChatToBottom();
        },
        ScrollChatToBottom()
        {
            const chatHistory = document.getElementById('ChatHistory');
            chatHistory.scrollTop = chatHistory.scrollHeight;
        },
        UpdatePromptCostEstimation()
        {
            const inp = document.getElementById('AI_UserInput');
            if (inp !== null)
            {
                this.Prompt = inp.value;

                // Estimate tokens
                // GPT-4o-mini -> $0.150/1M input tokens (2024/10/17)
                const estimatedTokens = Math.ceil(inp.value.length/4);
                const estimatedCost = estimatedTokens/1000000*0.15;
                
                this.CurrentPromptTokenEstimation = estimatedTokens;

                if (estimatedCost >= 0.00000105)
                {
                    this.CurrentPromptCostEstimation = estimatedCost;
                }
                else
                {
                    this.CurrentPromptCostEstimation = 0;
                }
            }
            else
            {
                this.CurrentPromptTokenEstimation = 0;
                this.CurrentPromptCostEstimation = 0;
            }
        },
        async GetProducts()
        {
            ShowLoading(true, 'ローディング中');

            const param = {
                SessionToken: this.$GetToken(),
            };

            this.SourceData = await axios.post(`${process.env.VUE_APP_BACKEND_URL}ai/data/products`, param)
            .then(response => {
                ShowLoading(false);
                return response.data;
            })
            .catch(error => {
                ShowLoading(false);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                console.log('Error when trying to receive source data', error);
                return null;
            });

            console.log('Received products', this.SourceData);
        },
        async GetSeries()
        {
            ShowLoading(true, 'ローディング中');
            
            const param = {
                SessionToken: this.$GetToken(),
            };

            const data = await axios.post(`${process.env.VUE_APP_BACKEND_URL}ai/data/series`, param)
            .then(response => {
                ShowLoading(false);
                return response.data;
            })
            .catch(error => {
                ShowLoading(false);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                console.log('Error when trying to receive source data', error);
                return null;
            });

            const tmp = [];
            for (let i = 0; i < data.length; i++)
            {
                tmp.push({label: data[i].name, value: data[i].id});
            }

            return tmp;
        },
        async GetBrands()
        {
            ShowLoading(true, 'ローディング中');
            
            const param = {
                SessionToken: this.$GetToken(),
            };

            const data = await axios.post(`${process.env.VUE_APP_BACKEND_URL}ai/data/brands`, param)
            .then(response => {
                ShowLoading(false);
                return response.data;
            })
            .catch(error => {
                ShowLoading(false);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                console.log('Error when trying to receive source data', error);
                return null;
            });

            const tmp = [];
            for (let i = 0; i < data.length; i++)
            {
                tmp.push({label: data[i].name, value: data[i].id});
            }

            return tmp;
        },
        async GetFactories()
        {
            ShowLoading(true, 'ローディング中');
            
            const param = {
                SessionToken: this.$GetToken(),
            };

            const data = await axios.post(`${process.env.VUE_APP_BACKEND_URL}ai/data/factories`, param)
            .then(response => {
                ShowLoading(false);
                return response.data;
            })
            .catch(error => {
                ShowLoading(false);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                console.log('Error when trying to receive source data', error);
                return null;
            });

            const tmp = [];
            for (let i = 0; i < data.length; i++)
            {
                tmp.push({label: data[i].name, value: data[i].id});
            }

            return tmp;
        },
        OnFactoryChange(newFactoryFilter)
        {
            this.SelectedFactories = [];

            for(let i = 0; i < newFactoryFilter.length; i++)
            {
                this.SelectedFactories.push(newFactoryFilter[i].value);
            }
            // this.SelectedFactories = newFactoryFilter;
        },
        OnSeriesChange(newSeriesFilter)
        {
            this.SelectedSeries = [];

            for(let i = 0; i < newSeriesFilter.length; i++)
            {
                this.SelectedSeries.push(newSeriesFilter[i].value);
            }
            // this.SelectedSeries = newSeriesFilter;
        },
        OnBrandChange(newBrandFilter)
        {
            this.SelectedBrands = [];

            for(let i = 0; i < newBrandFilter.length; i++)
            {
                this.SelectedBrands.push(newBrandFilter[i].value);
            }
            // this.SelectedBrands = newBrandFilter;
        },
    },
    data(){
        return{
            Prompt: '',
            CurrentPromptTokenEstimation: 0,
            CurrentPromptCostEstimation: 0,
            PromptDataOptions: [
                {label:'選択'},
                {label:'商品'},
                {label:'シリーズ'},
                {label:'ブランド'},
                {label:'工場'}
            ],
            FactoryOptions: [],
            SeriesOptions: [],
            BrandOptions: [],
            SelectedFactories: [],
            SelectedSeries: [],
            SelectedBrands: [],
        }
    }
}
</script>

<style>
#Notification
{
    color: rgb(185, 31, 31);
}

#InputContainer
{
    display: flex;
    align-items: center;
}

#SendMessageButton
{
    border: 1px solid black;
    border-radius: 55px;
    cursor: pointer;
    height: 100%;
    align-content: center;
    transition: 0.2s;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
}

#SendMessageButton:hover
{
    background-color: gray;
}

#AI_UserInput
{
    flex: 1;
    margin: 0px 10px;
    border: 1px solid gray;
}

#ChatHistory
{
    min-height: 45vh;
    max-height: 45vh;
    overflow-y: auto;
}

.Message
{
    padding: 10px;
    display: grid;
    margin-bottom: 10px;
}

.UserMessage
{
    background-color: rgb(135, 190, 177);
    padding: 16px 13px;
    border-radius: 8px;
    max-width: 50%;
    margin-left: auto;
    color: white;
}

.AIMessage
{
    background-color: rgb(157, 161, 160);
    padding: 16px 13px;
    border-radius: 8px;
    max-width: 50%;
    color: white;
}

.AIMessage table, th, td {
  border: 1px solid white;
}

.AIMessage table {
  width: 100%;
}

#CostEstimationBox
{
    margin-top: 10px;   
}

#CostEstimationBox div
{
    background-color: rgb(243, 243, 243);
    display: inline-block;
    padding: 0px 20px;
    color: #a0a0a0;
}

#AI_DataTypeSelection
{
    margin-top: 10px;
}
</style>